import { render, staticRenderFns } from "./TransactionTable.vue?vue&type=template&id=3afbfdec&scoped=true"
import script from "./TransactionTable.vue?vue&type=script&lang=js"
export * from "./TransactionTable.vue?vue&type=script&lang=js"
import style0 from "./TransactionTable.vue?vue&type=style&index=0&id=3afbfdec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afbfdec",
  null
  
)

export default component.exports